import { machines, sess } from './state.js';
import { openBatModal } from './batteri.js';
import { MASKINE_FELTER, renderMachines } from './maskiner.js';
import { esc, escJs, visTekst } from '../lib/tekst.js';
import { toast } from './ui.js';
import { sb } from '../lib/supabase.js';

export let productCache = {};
export async function lookupSKU(sku) {
  if (productCache[sku]) return productCache[sku];
  const { data } = await sb.from('products').select('sku,name,url,image_url').eq('sku', sku).single();
  if (data) productCache[data.sku] = data;
  return data || null;
}
export async function searchSKU(query) {
  const { data } = await sb.from('products').select('sku,name,url,image_url').or(`sku.ilike.%${query}%,name.ilike.%${query}%`).limit(8);
  return data || [];
}

export let searchTimer = null, selectedProduct = null;
export let searchTimerQr = null, selectedProductQr = null;

export async function liveSearchQr(query) {
  clearTimeout(searchTimerQr); selectedProductQr = null;
  const box = document.getElementById('searchResultsQr');
  if (query.length < 2) { box.style.display='none'; return; }
  searchTimerQr = setTimeout(async () => {
    const results = await searchSKU(query.trim());
    if (!results.length) { box.style.display='none'; return; }
    box.innerHTML = results.map(p => `
      <div onclick="selectProductQr('${escJs(p.sku)}','${escJs(p.name||'')}','${escJs(p.url||'')}','${escJs(p.image_url||'')}')"
           style="padding:10px 13px;cursor:pointer;border-bottom:1px solid var(--bdr);display:flex;align-items:center;gap:10px;transition:background .1s">
        ${p.image_url ? `<img src="${p.image_url}" style="width:32px;height:32px;object-fit:contain;border-radius:3px;flex-shrink:0">` : '<div style="width:32px;height:32px;background:var(--surf2);border-radius:3px;flex-shrink:0;display:flex;align-items:center;justify-content:center;font-size:16px">⚙️</div>'}
        <div style="flex:1;min-width:0">
          <div style="font-family:Oswald,sans-serif;font-size:13px;font-weight:500;white-space:nowrap;overflow:hidden;text-overflow:ellipsis">${visTekst(p.name)}</div>
          <div style="font-size:11px;color:var(--txt-m);letter-spacing:1px">${esc(p.sku)}</div>
        </div></div>`).join('');
    box.style.display = 'block';
  }, 280);
}

export function selectProductQr(sku, name, url, imageUrl) {
  selectedProductQr = { sku, name, url, image_url: imageUrl };
  document.getElementById('skuQr').value = sku + ' — ' + name;
  document.getElementById('searchResultsQr').style.display = 'none';
}

export async function addMachineFromSearchQr() {
  let prod = selectedProductQr;
  if (!prod) {
    const raw = document.getElementById('skuQr').value.trim().split(' ')[0].toUpperCase();
    prod = await lookupSKU(raw);
    if (!prod) { toast('❌ Varenummer ikke fundet'); return; }
  }
  const machType = document.getElementById('machTypeQr').value;
  await addMachine(prod, machType);
  document.getElementById('skuQr').value = '';
  document.getElementById('searchResultsQr').style.display = 'none';
  selectedProductQr = null;
}

export async function liveSearch(query) {
  clearTimeout(searchTimer); selectedProduct = null;
  const box = document.getElementById('searchResults');
  if (query.length < 2) { box.style.display='none'; return; }
  searchTimer = setTimeout(async () => {
    const results = await searchSKU(query.trim());
    if (!results.length) { box.style.display='none'; return; }
    box.innerHTML = results.map(p => `
      <div onclick="selectProduct('${escJs(p.sku)}','${escJs(p.name||'')}','${escJs(p.url||'')}','${escJs(p.image_url||'')}')"
           style="padding:10px 13px;cursor:pointer;border-bottom:1px solid var(--bdr);display:flex;align-items:center;gap:10px;transition:background .1s">
        ${p.image_url ? `<img src="${p.image_url}" style="width:32px;height:32px;object-fit:contain;border-radius:3px;flex-shrink:0">` : '<div style="width:32px;height:32px;background:var(--surf2);border-radius:3px;flex-shrink:0;display:flex;align-items:center;justify-content:center;font-size:16px">⚙️</div>'}
        <div style="flex:1;min-width:0">
          <div style="font-family:Oswald,sans-serif;font-size:13px;font-weight:500;white-space:nowrap;overflow:hidden;text-overflow:ellipsis">${visTekst(p.name)}</div>
          <div style="font-size:11px;color:var(--txt-m);letter-spacing:1px">${esc(p.sku)}</div>
        </div></div>`).join('');
    box.style.display = 'block';
  }, 280);
}

export function selectProduct(sku, name, url, imageUrl) {
  selectedProduct = { sku, name, url, image_url: imageUrl };
  document.getElementById('skuTxt').value = sku + ' — ' + name;
  document.getElementById('searchResults').style.display = 'none';
}

export async function addMachineFromSearch() {
  let prod = selectedProduct;
  if (!prod) {
    const raw = document.getElementById('skuTxt').value.trim().split(' ')[0].toUpperCase();
    prod = await lookupSKU(raw);
    if (!prod) { toast('❌ Varenummer ikke fundet'); return; }
  }
  const machType = document.getElementById('machTypeSku').value;
  await addMachine(prod, machType);
  document.getElementById('skuTxt').value = '';
  document.getElementById('searchResults').style.display = 'none';
  selectedProduct = null;
}

export function addMachineFromInput(inputId) {
  const sku=document.getElementById(inputId).value.trim().toUpperCase(); if (!sku) return;
  lookupSKU(sku).then(prod => {
    if (!prod) { toast('❌ SKU ikke fundet: '+sku); return; }
    addMachine(prod); document.getElementById(inputId).value='';
  });
}

/**
 * Finder et navn, kunden kan skelne maskinerne på.
 *
 * En kunde må gerne have to ens maskiner — den hårde spærring i
 * databasen er fjernet. Men to poster med præcis samme navn er ikke til
 * at kende fra hinanden, så nummer to får et tal. Navnet kan ændres
 * bagefter med Omdøb inde på maskinen.
 */
function entydigtNavn(navn, sku) {
  const brugte = new Set(machines.filter(m => m.sku === sku).map(m => m.name));
  if (!brugte.has(navn)) return navn;
  let n = 2;
  while (brugte.has(`${navn} (${n})`)) n++;
  return `${navn} (${n})`;
}

export async function addMachine(prod, machType) {
  const navn = entydigtNavn(prod.name, prod.sku);
  const { data, error } = await sb.from('machines').insert({ sku:prod.sku, name:navn, user_id:sess.user.id, machine_type: machType||'standard' })
    .select(MASKINE_FELTER).single();
  if (error) { toast('❌ '+(error.message||'Fejl')); return; }
  data._prodMeta = prod; machines.unshift(data); renderMachines();
  toast('✓ '+navn+' tilføjet!');
  if (machType && machType !== 'standard') openBatModal(data.id);
}
